import { edmCampaign } from '@bingads-webui/edm-campaign';

const campaignEDM = edmCampaign.types.resolve('Model.Campaign');
const campaignResource = new campaignEDM.ResourceIdentifier();

export const createOrUpdateCampaign = (data) => {
  const createOrUpdateCall = data && data.Id ?
    campaignResource.bulkUpdate.bind(campaignResource) :
    campaignResource.bulkCreate.bind(campaignResource);
  return createOrUpdateCall(data);
};

export const readCampaign = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .get({
      select: ['CampaignConversionGoal/Goals', 'Budget'],
    })
    .toPromise();

export const readCampaignCriterions = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .CampaignCriterions
    .$cast('Model.CampaignCriterion')
    .get({
      top: 50,
      filter: {
        where:
          [
            "isof(Criterion,'Model.LocationCriterion')",
            "isof(Criterion,'Model.RadiusCriterion')",
            "isof(Criterion,'Model.LocationIntentCriterion')",
            "isof(Criterion,'Model.CompanyNameCriterion')",
            "isof(Criterion,'Model.IndustryCriterion')",
            "isof(Criterion,'Model.JobFunctionCriterion')",
            "isof(Criterion,'Model.JobTitleCriterion')",
            "isof(Criterion,'Model.JobSeniorityCriterion')",
            "isof(Criterion,'Model.AgeCriterion')",
            "isof(Criterion,'Model.GenderCriterion')",
          ].join(' or '),
      },
    })
    .toPromise();
